import { useState } from 'react';
import { MessageScreen } from '@/components/MessageScreen/MessageScreen';
import { useConfig } from '@/hooks/useConfig/useConfig';
import * as icons from '@cof/omni-gravity-icons-react';
import { FlexContainer, IconButton } from '@cof/omni-react';
import styled from '@emotion/styled';

const LinkContainer = styled(FlexContainer)`
  margin-top: 10px;
  text-align: center;
  background-color: #f4f4f4;
  border-radius: 8px;
  padding: 8px;
  color: #6e6e6e;
`;

export const BrowserError = ({
  title,
  body,
  link,
}: {
  title: string;
  body: string;
  link: string;
}) => {
  const { locale, content } = useConfig();
  const [buttonText, setButtonText] = useState(
    content.browserNotSupported.primaryButton?.label[locale] || 'Copy Link',
  );

  const handleClick = () => {
    navigator.clipboard.writeText(link);
    setButtonText(
      content.browserNotSupported.secondaryButton?.label[locale] || 'Copied',
    );
  };
  return (
    <MessageScreen
      iconPath={`${content.config.urlBase}${content.browserNotSupported.img.src}`}
      iconSize={content.browserNotSupported.img.width}
      title={title}
      titleSize={19}
      body={
        <>
          {body}
          <LinkContainer>{link}</LinkContainer>
        </>
      }
      button={
        <IconButton
          onClick={handleClick}
          icon={
            buttonText === 'Copied'
              ? icons.UiCheckmarkLinedSmall
              : icons.UiCopyLinedSmall
          }
          iconPosition={buttonText === 'Copied' ? 'start' : 'end'}
          rank="primary"
        >
          {buttonText}
        </IconButton>
      }
    />
  );
};
